class BreakpointMatcher {
  constructor() {
    this.breakPoint = {
      xs: "359px",
      sm: "639px",
      md: "767px",
      lg: "1023px",
      xl: "1279px",
      "2xl": "1335px",
      "3xl": "1439px",
      "4xl": "1535px",
      "5xl": "1919px",
    };
  }

  matchMedia(breakPoint) {
    return window.matchMedia(
      "(max-width: " + this.breakPoint[breakPoint] + ")"
    );
  }
}

export default BreakpointMatcher;
